import { generateParamsFromObj } from "@/common/utils";
import { axiosInstance } from "../../axios";
import { useQuery } from "@tanstack/react-query";
import { PaginatedResponse, GroupedQuoteType } from "@/common/types";

const getQuoteGroupByQuoteReq = async (
  skip: string,
  filters: any,
  searchQ: string
) => {
  const params = generateParamsFromObj(filters);
  const searchFields = ["locationId", "endCustomerName", "quoteReqId"];
  params.append("take", "10"), params.append("skip", skip);
  searchFields.forEach((el) => params.append("searchFields", el));
  params.append("filters[searchQ]", searchQ);
  return await axiosInstance
    .get("/quotes/lines/customer", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetQuoteByQuoteReq = (
  skip: string,
  filters: any,
  searchQ: string,
  isEnabled?: boolean
) => {
  return useQuery<PaginatedResponse<GroupedQuoteType>>({
    queryKey: [skip, filters, searchQ, "customer", "quotes"],
    queryFn: () => getQuoteGroupByQuoteReq(skip, filters, searchQ),
    enabled: isEnabled,
  });
};
export default useGetQuoteByQuoteReq;
// for customer quote view
